"use strict";

require("core-js/modules/es.array.reduce.js");

exports.__esModule = true;
exports.stateProp = exports.connectProps = exports.actionProp = void 0;

require("core-js/modules/es.array.reduce.js");

var _reactRedux = require("react-redux");

var type = Symbol('PROP_TYPE');
var STATE_PROP = 'STATE_PROP';
var ACTION_PROP = 'ACTION_PROP';

var stateProp = function stateProp(mapStateToProp) {
  mapStateToProp[type] = STATE_PROP;
  return mapStateToProp;
};

exports.stateProp = stateProp;

var actionProp = function actionProp(mapActionToProp) {
  mapActionToProp[type] = ACTION_PROP;
  return mapActionToProp;
};

exports.actionProp = actionProp;

var isActionPropCreator = function isActionPropCreator(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      propType = _ref[type];

  return propType === ACTION_PROP;
};

var isStatePropCreator = function isStatePropCreator(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
      propType = _ref2[type];

  return propType === STATE_PROP;
};

var createStatePropCreators = function createStatePropCreators(statePropCreators, state, ownProps) {
  if (statePropCreators === void 0) {
    statePropCreators = [];
  }

  return statePropCreators.reduce(function (props, propCreator) {
    return Object.assign({}, props, propCreator(state, ownProps));
  }, {});
}; // const statePropCreators = (propCreators = [], state, ownProps) =>
//   createStatePropCreators(
//     propCreators.filter(isStatePropCreator),
//     state,
//     ownProps,
//   );


var actionPropCreators = function actionPropCreators(propCreators, dispatch, getOwnProps) {
  if (propCreators === void 0) {
    propCreators = [];
  }

  return propCreators.filter(isActionPropCreator).reduce(function (props, propCreator) {
    return Object.assign({}, props, propCreator(dispatch, getOwnProps()));
  }, {});
};

var connectProps = function connectProps() {
  for (var _len = arguments.length, propsCreators = new Array(_len), _key = 0; _key < _len; _key++) {
    propsCreators[_key] = arguments[_key];
  }

  return function (Component) {
    function selectorFactory(dispatch) {
      var ownProps = {};
      var result = {};
      var actionProps = actionPropCreators(propsCreators, dispatch, function () {
        return ownProps;
      });
      var statePropCrtrs = propsCreators.filter(isStatePropCreator);
      return function (nextState, nextOwnProps) {
        if (nextOwnProps === void 0) {
          nextOwnProps = {};
        }

        var nextResult = Object.assign({}, nextOwnProps, actionProps, createStatePropCreators(statePropCrtrs, nextState, nextOwnProps));
        ownProps = nextOwnProps;
        var isShallowEqual = Object.keys(nextResult).every(function (key) {
          return nextResult[key] === result[key];
        });

        if (!isShallowEqual) {
          result = nextResult;
        }

        return result;
      };
    }

    return (0, _reactRedux.connectAdvanced)(selectorFactory)(Component);
  };
}; // const isOfValidType = ({ [type]: propType } = {}) =>
//   propType === STATE_PROP || propType === ACTION_PROP;
// const combinePropCreators = (
//   propCreators = [],
//   { state, dispatch },
//   ownProps,
// ) =>
//   propCreators.filter(isOfValidType).reduce(
//     (props, propCreator) => ({
//       ...props,
//       ...propCreator(
//         propCreator[type] === STATE_PROP ? state : dispatch,
//         ownProps,
//       ),
//     }),
//     {},
//   );
// const connectProps = (...propsCreators) => Component => {
//   function selectorFactory(dispatch) {
//     return (state, ownProps = {}) => ({
//       ...ownProps,
//       ...combinePropCreators(propsCreators, { dispatch, state }, ownProps),
//     });
//   }
//
//   return connectAdvanced(selectorFactory)(Component);
// };


exports.connectProps = connectProps;